import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingSubtitle } from '@/pages/Onboarding/components/Subtitle';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';
import { useOnboarding } from '@/pages/Onboarding/context';
import { getMostPreferredCategory } from '@/pages/Onboarding/utils/getMostPreferredCategory';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

import { stepDataByInteractionIdMap } from './constants';
import { ReplikaRelationshipsStyles } from './Relationships.styles';

export const OnboardingReplikaRelationships: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Relationships',
      });
    }
  }, []);

  const { watch } = useFormContext<LayoutDataType>();
  const categories = watch('categories');
  const interaction = watch('interaction') || 'casual_chatting';

  const mostPreferredCategory = getMostPreferredCategory(categories);

  const stepData = stepDataByInteractionIdMap[interaction];

  const { wizard } = useOnboarding();

  const handleNextStep = (): void => {
    wizard.nextStep();
  };

  return (
    <ReplikaRelationshipsStyles>
      <IonContent>
        <div className="img-container">
          <img
            src={`https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/${mostPreferredCategory.key}/leveling.png`}
            alt="relationships"
          />
        </div>
        <OnboardingTitle>{stepData.title}</OnboardingTitle>
        <OnboardingSubtitle>{stepData.subtitle}</OnboardingSubtitle>
      </IonContent>

      <OnboardingFooter onContinue={handleNextStep} />
    </ReplikaRelationshipsStyles>
  );
};
